'use strict';
/* ===================================================================================== @preserve =
 ___  _   _    _
/   || | | |  | |
\__  | | | |  | |  __
/    |/  |/_) |/  /  \_/\/
\___/|__/| \_/|__/\__/  /\_/
              |\
              |/
Ajaxinate
version v2.0.4
https://github.com/Elkfox/Ajaxinate
Copyright (c) 2017 Elkfox Co Pty Ltd
https://elkfox.com
MIT License
================================================================================================= */

let Ajaxinate = function ajaxinateConstructor(config) {
    let settings = config || {};
    /*
      pagination: Selector of pagination container
      container: Selector of repeating content
      offset: 0, offset the number of pixels before the bottom to start loading more on scroll
      loadingText: 'Loading', The inner HTML changed during loading
      callback: null, function to callback after a new page is loaded
    */

    let defaultSettings = {
        method: 'scroll',
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        offset: 0,
        loadingText: '<span>Loading</span>',
        callback: null
    }; // Merge configs

    this.settings = Object.assign(defaultSettings, settings);
    this.addScrollListeners = this.addScrollListeners.bind(this);
    this.addClickListener = this.addClickListener.bind(this);
    this.checkIfPaginationInView = this.checkIfPaginationInView.bind(this);
    this.stopMultipleClicks = this.stopMultipleClicks.bind(this);
    this.removeClickListener = this.removeClickListener.bind(this);
    this.removeScrollListener = this.removeScrollListener.bind(this);
    this.destroy = this.destroy.bind(this);
    this.containerElement = document.querySelector(this.settings.container);
    this.paginationElement = document.querySelector(this.settings.pagination);
    this.initialize();
};

Ajaxinate.prototype.initialize = function initializeTheCorrectFunctionsBasedOnTheMethod() {
    if (this.containerElement) {
        let initializers = {
            click: this.addClickListener,
            scroll: this.addScrollListeners
        };
        initializers[this.settings.method]();
    }
};

Ajaxinate.prototype.addScrollListeners = function addEventListenersForScrolling() {
    if (this.paginationElement) {
        document.addEventListener('scroll', this.checkIfPaginationInView);
        window.addEventListener('resize', this.checkIfPaginationInView);
        window.addEventListener('orientationchange', this.checkIfPaginationInView);
    }
};

Ajaxinate.prototype.addClickListener = function addEventListenerForClicking() {
    if (this.paginationElement) {
        this.nextPageLinkElement = this.paginationElement.querySelector('a');
        this.clickActive = true;

        if (typeof this.nextPageLinkElement !== 'undefined' && this.nextPageLinkElement !== null) {
            this.nextPageLinkElement.addEventListener('click', this.stopMultipleClicks);
        }
    }
};

Ajaxinate.prototype.stopMultipleClicks = function handleClickEvent(event) {
    event.preventDefault();

    if (this.clickActive) {
        this.nextPageLinkElement.innerHTML = this.settings.loadingText;
        this.nextPageUrl = this.nextPageLinkElement.href;
        this.clickActive = false;
        this.loadMore();
    }
};

Ajaxinate.prototype.checkIfPaginationInView = function handleScrollEvent() {
    let top = this.paginationElement.getBoundingClientRect().top - this.settings.offset;
    let bottom = this.paginationElement.getBoundingClientRect().bottom + this.settings.offset;

    if (top <= window.innerHeight && bottom >= 0) {
        this.nextPageLinkElement = this.paginationElement.querySelector('a');
        this.removeScrollListener();

        if (this.nextPageLinkElement) {
            this.nextPageLinkElement.innerHTML = this.settings.loadingText;
            this.nextPageUrl = this.nextPageLinkElement.href;
            this.loadMore();
        }
    }
};

Ajaxinate.prototype.loadMore = function getTheHtmlOfTheNextPageWithAnAjaxRequest() {
    this.request = new XMLHttpRequest();

    this.request.onreadystatechange = function success() {
        if (this.request.readyState === 4 && this.request.status === 200) {
            let newContainer = this.request.responseXML.querySelectorAll(this.settings.container)[0];
            let newPagination = this.request.responseXML.querySelectorAll(this.settings.pagination)[0];
            this.containerElement.insertAdjacentHTML('beforeend', newContainer.innerHTML);
            this.paginationElement.innerHTML = newPagination.innerHTML;

            if (this.settings.callback && typeof this.settings.callback === 'function') {
                this.settings.callback(this.request.responseXML);
            }

            this.initialize();
        }
    }.bind(this);

    this.request.open('GET', this.nextPageUrl);
    this.request.responseType = 'document';
    this.request.send();
};

Ajaxinate.prototype.removeClickListener = function removeClickEventListener() {
    this.nextPageLinkElement.removeEventListener('click', this.stopMultipleClicks);
};

Ajaxinate.prototype.removeScrollListener = function removeScrollEventListener() {
    document.removeEventListener('scroll', this.checkIfPaginationInView);
    window.removeEventListener('resize', this.checkIfPaginationInView);
    window.removeEventListener('orientationchange', this.checkIfPaginationInView);
};

Ajaxinate.prototype.destroy = function removeEventListenersAndRemoveThis() {
    let destroyers = {
        click: this.removeClickListener,
        scroll: this.removeScrollListener
    };
    destroyers[this.settings.method]();
    return this;
};
